import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppService } from '@core/services/app/app-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { TokenHolderService } from '@core/services/token-holder/token-holder-api';
import { Observable } from 'rxjs';
import { CanActivate, CanActivateChild } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private appService: AppService,
    private privilegeService: PrivilegeService,
    private tokenHolderService: TokenHolderService,
    private orgAndStockroomService: OrgAndStockroomService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const auth_token = this.tokenHolderService.getAuthToken();
    const im_context = this.orgAndStockroomService.getStockroomAndOrg();
    const c_org_stockroom = this.orgAndStockroomService.getStockroomAndOrgName();
    const privilege = this.privilegeService.getPrivilege();
    const config: any = this.appService.getUserData();
    const isAdminConsole: any = sessionStorage.getItem('isAdminConsole');

    if (!auth_token || !im_context) {
      this.tokenHolderService.logoutSession();
      return false;
    }
    if (!config) {
      this.router.navigate(["/"]);
      return false;
    }
    if (c_org_stockroom && privilege) {
      this.router.navigate(["/app"]);
      return false;
    }

    return true;

  }

}
